import _ from 'lodash'
import {
  CategoryDetails,
  Export,
  Import,
  ParagraphsEditor,
  PropertyMatrix,
} from '~/pages'
import TreeAsList from '~/pages/TreeAsList'

const matrixRegExp = /^#matrix\/(\d+)$/

const actions = [
  // {
  //   path: 'preview',
  //   name: 'Podgląd',
  // },
  {
    path: 'import',
    name: 'Import',
    component: <Import />,
    deep: false,
  },
  {
    path: 'specs',
    name: 'Spec. Tech.',
    getComponent: ({ location, subCategory }) => {
      if (!subCategory) {
        return <TreeAsList />
      }
      const match = location.hash.match(matrixRegExp)
      if (match) {
        return <PropertyMatrix property_id={parseInt(match[1])} />
      } else {
        return <CategoryDetails />
      }
    },
    getContainer: ({ location, subCategory }) => {
      return subCategory && location.hash.match(matrixRegExp)
        ? {
            maxWidth: false,
            sx: { display: 'flex', flexDirection: 'column', height: '100%' },
          }
        : undefined
    },
    getWithScrollBar: ({ location, subCategory }) =>
      !subCategory || !location.hash.match(matrixRegExp),
  },
  {
    path: 'html',
    name: 'Opisy',
    getComponent: ({ location, subCategory }) => {
      return !subCategory ? (
        <TreeAsList />
      ) : (
        <ParagraphsEditor key={location.pathname} />
      )
    },
    getContainer: ({ subCategory }) => {
      const common = {
        sx: {
          backgroundColor: 'background.paper',
        },
      }
      return subCategory
        ? _.merge(common, {
            maxWidth: false,
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              overflow: 'clip',
            },
          })
        : common
    },
    getWithScrollBar: ({ subCategory }) => !subCategory,
  },
  // {
  //   path: 'pictures',
  //   name: 'Zdjęcia',
  // },
  {
    path: 'export',
    name: 'Eksport',
    getComponent: ({ subCategory }) => {
      return subCategory ? <Export /> : <TreeAsList />
    },
  },
  // {
  //   path: 'prod-cards',
  //   name: 'Karty prod.',
  // },
  // {
  //   path: 'reports',
  //   name: 'Raporty',
  // },
  // {
  //   path: 'promo',
  //   name: 'Promo',
  // },
  // {
  //   path: 'upload',
  //   name: 'Upload',
  // },
]

export default actions
